import PersianLocale from 'antd/es/locale/fa_IR';
import dayjs from 'dayjs';
import 'dayjs/locale/fa';
import jalaliday from 'jalali-plugin-dayjs';

dayjs.extend(jalaliday);
dayjs.calendar('jalali');
dayjs.locale('fa');

const { DatePicker: DatePickerPersianLocale, Calendar: CalendarPersianLocale } =
  PersianLocale;
const { lang: DatePickerPersianLang } = DatePickerPersianLocale ?? {};
const { lang: CalendarPersianLang } = CalendarPersianLocale ?? {};
const {
  Ls: { fa: faLocalizationDayjs },
} = dayjs;
const jalaliMonths: string[] =
  'jmonths' in faLocalizationDayjs
    ? (faLocalizationDayjs.jmonths as string[])
    : [];

const locale: typeof PersianLocale = {
  ...PersianLocale,
  DatePicker: DatePickerPersianLocale
    ? {
        ...DatePickerPersianLocale,
        lang: {
          ...DatePickerPersianLang!,
          shortMonths: jalaliMonths,
        },
      }
    : undefined,
  Calendar: CalendarPersianLocale
    ? {
        ...CalendarPersianLocale,
        lang: {
          ...CalendarPersianLang!,
          shortMonths: jalaliMonths,
        },
      }
    : undefined,
};

export { locale };
